import {IHomeworkQuestionSet} from "@/consts/interfaces";
import { ACHIEVEMENT_CONDITION_MAP,HOMEWORK_PROGRESS_QUESTIONSET_STATUS_MAP, HOMEWORK_STATUS_CLASS } from "@/consts/homework";

// 宿題情報を取得するロジック
class HomeworkInfo {
    private questionSetId: number | null;
    private hwQuestionSets: IHomeworkQuestionSet[];
  
    constructor(questionSetId: number | null, questionSets: IHomeworkQuestionSet[]) {
      this.questionSetId = questionSetId;
      this.hwQuestionSets = questionSets;
    }
    get info(){
      let hw_info = [];
      let hw_q_sets = [];

      if(this.questionSetId){
        hw_q_sets = this.hwQuestionSets.filter(h => this.questionSetId === h.question_set_id);
      }else{
        hw_q_sets = this.hwQuestionSets;
      }
  
      if (hw_q_sets.length !== 0) {
        hw_q_sets.slice(0, 3).forEach(item => {
          const endDate = new Date(item.end_datetime);
          const result = {
            month: endDate.getMonth() + 1,
            day: endDate.getDate(),
            dayOfWeek: ['日', '月', '火', '水', '木', '金', '土'][endDate.getDay()],
            time: ("0" + endDate.getHours()).slice(-2) + ":" + ("0" + endDate.getMinutes()).slice(-2),
            status: HOMEWORK_PROGRESS_QUESTIONSET_STATUS_MAP[item.question_set_status],
            statusClass: HOMEWORK_STATUS_CLASS[item.question_set_status],
            achievement: ACHIEVEMENT_CONDITION_MAP[item.achievement_condition],
            relearning: item.relearning_required ? "学習済みでも、もう一度取り組もう" : ""
          };
          hw_info.push(result);
        });
  
        return hw_info;
      }
      return [];
    }
    homework_ids(homework_id: number){
      let hw_ids:{[id: number] : number} = {[homework_id]: homework_id};
      let hw_q_sets:IHomeworkQuestionSet[] = [];

      if(this.questionSetId){
        hw_q_sets = this.hwQuestionSets.filter(h => this.questionSetId === h.question_set_id);
      }else{
        hw_q_sets = this.hwQuestionSets;
      }
      hw_q_sets.forEach(item => {
        hw_ids[item.homework_id] = item.homework_id
      })
      return hw_ids
    }
  }
  
  export default HomeworkInfo